import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 35px;
  color: #272727;
`;

export const Container = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
